import {
  deliveryRisk,
  type insightTones,
} from "@/features/quote-builder/pricing/pricing-rules";

export function shortDate(value: string) {
  return new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${value.slice(0, 10)}T00:00:00Z`));
}

/** The arrival against the customer's deliver-by date, in days, as the quote builder measures it. */
export function deliveryTiming(
  deliverBy: string | null | undefined,
  arrival: string | null | undefined,
): { tone: keyof typeof insightTones; late: boolean; text: string } | null {
  if (!arrival) return null;
  const risk = deliveryRisk(deliverBy?.slice(0, 10), arrival);
  const arrives = `Arrives about ${shortDate(arrival)}`;
  if (risk.slack === null || !deliverBy) {
    return { tone: risk.tone, late: false, text: arrives };
  }
  const days = Math.abs(risk.slack);
  const relation =
    risk.slack < 0
      ? `${days} day${days === 1 ? "" : "s"} after`
      : risk.slack === 0
        ? "on"
        : `${days} day${days === 1 ? "" : "s"} before`;
  return {
    tone: risk.tone,
    late: risk.slack < 0,
    text: `${arrives}, ${relation} the ${shortDate(deliverBy)} deliver-by date`,
  };
}

